import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppMonitoring } from '../../app-services/monitoring/monitor.app';
import { AppServiceWorkerUpdate } from '../../app-services/service-worker/service-worker-update.app';
import { ErrorSeverityLevel } from '../../../config/config.interface';

@Component({
  selector: 'app-page-not-found',
  imports: [],
  templateUrl: './page-not-found.component.html',
  styleUrl: './page-not-found.component.scss'
})
export class PageNotFoundComponent implements OnInit {
  private readonly appMonitor = inject(AppMonitoring);
  private readonly appServiceWorkerUpdate = inject(AppServiceWorkerUpdate);
  private readonly router = inject(Router);

  attemptedUrl: string;
  isCheckingForNewVersion = true;

  constructor() {
    // Get the attempted URL
    this.attemptedUrl = this.router.url;
  }

  ngOnInit(): void {
    this.recoverFromStaleVersion();
  }

  /**
   * A URL the running build cannot match may be a URL a newer build introduced — the service worker
   * serves the previously cached version until a new one is activated. Check for a newer version
   * before reporting the route as missing, so a stale build reloads itself instead of showing a 404.
   */
  private async recoverFromStaleVersion(): Promise<void> {
    const isReloading = await this.appServiceWorkerUpdate.recoverFromStaleVersion(this.attemptedUrl);
    if (isReloading) {
      // The page is about to reload onto the newer version — this was not a real 404.
      return;
    }

    this.isCheckingForNewVersion = false;
    this.appMonitor.logException(
      this,
      `Page not found: ${this.attemptedUrl}`,
      { attemptedUrl: this.attemptedUrl },
      ErrorSeverityLevel.Error
    );
  }
}
